<template>
    <div class="container" style="margin-top: 60px">
        <br>
        <br>
        <div class="container img-area-logo">
        </div>
        <br>
        <div class="container img-area">
            <h3>Área do <strong>vistoriador</strong></h3>
        </div>
        <div class="container login-area color">
            <div class="container" style="padding: 30px">
                <div class="form-row padding">
                    <div class="form-group">
                        <label class="padding-lab">Token [Código de acesso]:</label>
                        <input v-model="user.token" class="form-control form-control-mod" type="text"
                            v-on:keyup.enter="realizarValidacaoCaptcha()">
                    </div>
                </div>
                <div class="form-row padding">
                    <div class="form-group">
                        <label class="padding-lab">E-mail:</label>
                        <input v-model="user.email" class="form-control form-control-mod" type="email"
                            v-on:keyup.enter="realizarValidacaoCaptcha()">
                    </div>
                </div>
                <div class="form-row padding">
                    <div class="form-group">
                        <label class="padding-lab">Senha:</label>
                        <input v-model="user.senha" class="form-control form-control-mod" type="password"
                            v-on:keyup.enter="realizarValidacaoCaptcha()">
                    </div>
                </div>
                <br>
                <div style="display: flex; justify-content: right; width: 270px;">
                    <div class="form-group float-right">
                        <img alt="" class="btn" href="#" src="../assets/img/btnLogin.gif" v-on:click="realizarValidacaoCaptcha()">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>

    <div
        class="g-recaptcha"
        data-sitekey="6LezEMQcAAAAABe7D4vEkg_wbhk6o4egdV9dFabz"
        data-size="invisible"
    ></div>

    <div class="links">
        <ul>
            <li style='text-align:center'><a href="https://esqueciminhasenha.vexsoft.com.br">Esqueci minha senha e/ou
                token</a></li>
        </ul>
        <ul>
            <li style='text-align:center'><a href="https://cadastro.vexsoft.com.br">Ainda não possuo cadastro.</a></li>
        </ul>
    </div>
</template>

<script>
import APIv3 from "../services/apiv3-endpoints";
import ApiUsuarios from "../services/api-usuarios-endpoints";
import moment from 'moment'

export default {
    name: "Login",
    data() {
        return {
            user: {
                token: "",
                email: "",
                senha: "",
            },
        }
    },

    methods: {
        loginSuccessful(response) {
            if (!this.user.token) {
                this.loginFailed()
                return
            }

            const token = this.user.token
            const email = this.user.email
            const usuario = response.data[0]

            console.log(usuario)

            if (usuario.politica_senha_ativo == 1) {
                if (usuario.data_ultima_alteracao_senha === null) {
                    this.abrirRedefinicaoSenha(email, token)
                    return
                } else {
                    let dataVencimentoSenha
                    if (usuario.tipo == 'Administrador')
                        dataVencimentoSenha = moment(usuario.data_ultima_alteracao_senha).add(usuario.adm_validade_dias, 'days')
                    else
                        dataVencimentoSenha = moment(usuario.data_ultima_alteracao_senha).add(usuario.user_validade_dias, 'days')

                    if (moment(new Date()).isAfter(dataVencimentoSenha)) {
                        this.abrirRedefinicaoSenha(email, token)
                        return
                    }
                }
            }

            localStorage.token = token.toUpperCase()
            localStorage.email = email
            localStorage.nomeUsuario = usuario.nome
            localStorage.idUsuario = usuario.id
            localStorage.mostrarMensagem = true

            if (usuario.tipo == 'Administrador') {
                alert('Atenção, essa é uma aplicação destinada a vistoriadores. Apenas vistorias realizadas por vistoriadores logados serão mostradas.')
            }

            this.$router.push({ path: '/Home' })
        },

        abrirRedefinicaoSenha(email, token) {
            APIv3.abrirRedefinicaoSenha(email, token)
                .then(() => {
                    this.$swal.fire({
                        icon: "warning",
                        title: 'Sua senha expirou! Enviamos no seu email um link para você definir uma nova senha.'
                    })
                })
                .catch(() => {
                    this.$swal.fire({
                        icon: "warning",
                        title: 'Sua senha expirou! Enviamos no seu email um link para você definir uma nova senha.'
                    })
                })
        },

        loginFailed() {
            localStorage.removeItem("token")
        },

        realizarValidacaoCaptcha(){
            try {
                const vm = this
                // eslint-disable-next-line
                grecaptcha.ready(function () {
                    // eslint-disable-next-line
                    grecaptcha.execute('6Ld2MxMpAAAAAFPrKzSYOlm9tlzY1UK3GxcF0tsp', { action: 'submit' })
                        .then(async function (token) {
                            vm.authUser(token)
                        });
                });
            } catch (error) {
                console.error(error)
            }
        },

        authUser(tokenCaptcha) {
            let data = {
                token: this.user.token,
                email: this.user.email,
                senha: this.user.senha,
                token_captcha: tokenCaptcha,
                aplicativo: "area-vistoriador.vexsoft.com.br"
            }

            ApiUsuarios.autenticarUsuario(data)
                .then((response) => {
                    this.loginSuccessful(response)
                })
                .catch((err) => {
                    this.showErrorAlert(err.response.data)
                    this.loginFailed()
                })
        },
        showErrorAlert(msg) {
            this.$swal("Erro!", msg, 'error')
        },
    },
}
</script>

<style>

.links {
    color: rgb(65, 76, 175);
    justify-content: center;
    flex-direction: column;
    text-align: center;
    margin-right: 20px;
}

ul {
    list-style-type: none;
}

a:link {
    text-decoration: none;
}


.login-area {
    width: 340px;
    height: 325px;
    color: #fff;
}

.img-area {
    text-align: center;
    width: 340px;
    height: 68px;
    background-size: 100%;
    background-image: linear-gradient(#93c802, #5ca314);
    color: #135502;
    text-shadow: 0 0 2px #ffffff, 0 0;
    padding: 15px;
}

.img-area-logo {
    background-image: url('../assets/img/logologin.png');
    width: 200px;
    height: 50px;
    background-size: 100%;

}

.color {
    background-color: #002E5B;
}

.form-control-mod {
    height: 30px;
}

.padding {
    padding-bottom: 15px;
}

.padding-lab {
    padding-bottom: 5px;
}

</style>